import axios from 'axios';
import ReactPaginate from 'react-paginate'
import React, { Component } from 'react'
import "../../services/ApiRest";
//import "../../secretaria/secretaria.css";
import swal from 'sweetalert';
import { ApiUrl } from '../../services/ApiRest';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import $ from 'jquery';

const urlListPeriodos = ApiUrl + "listperiodostodos" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlListarCarreras = ApiUrl + "listarcarreras" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const UrlListarAsignMatCiclo = ApiUrl + "ListarAsignMatCiclo" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlListEstudMatriPlataf = ApiUrl + "listestudmatriplataf" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlInfoCarrera = ApiUrl + "infocarrselect" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlInfoPeriod = ApiUrl + "infoperiodselect" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlDatosEstudianteCed = ApiUrl + "datosestudxced" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlModifObservacion = ApiUrl + "modfobservacionestud" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlListParalelos = ApiUrl + "listodosparalelos" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlCambiarEstadoEva = ApiUrl + "cambiarestadomateva" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";

let listaauxiliar = [];
const itemsPerPage = 10;

export default class listaMatriculados extends Component {

    constructor(props) {
        super(props)
        this.state = {
            carrera: [],
            estado: "",
            listasignaturas: [],
            listaperiodos: [],
            listparalelos: [],
            idPeriodo: 1,
            listaasigencab: [],
            listaniveles: [],
            //Variables para búsqueda
            estud: [],
            EstudianteBackup: [],
            textBuscar: "",
            //variables para paginacion
            currentItems: null,
            pageCount: 0,
            itemOffset: 0,
            count: 0,
            //encabezado de la tabla record
            txt_periodo: "",
            txt_ciclo: "",
            txt_fechaact: "",
            txt_paralelo: "",
            ListEstActaCalif: [],

        }
        this.handleChange = this.handleChange.bind(this);
        this.escFunction = this.escFunction.bind(this);
    }
    escFunction(event) {
        if (event.key === "Escape") {
            this.setState({ modalReportAsignatutasEst: false });
        }
    }
    handleChange = async (e) => {
        await this.setState({ [e.target.name]: e.target.value })
        this.setState({ estado: "" });
    }

    componentDidMount() {
        //Listar las carreras
        axios.get(urlListarCarreras)
            .then(res => {
                const carrera = res.data;
                this.setState({ carrera });
            })

        //listar todos los periodos
        axios
            .get(urlListPeriodos)
            .then(response => {
                const listaperiodos = response.data.data;
                const cant = listaperiodos.length;
                if (cant != 0) {
                    this.setState({ listaperiodos });
                }
            })
        //Listar todos los paralelos
        axios
            .get(urlListParalelos)
            .then(response => {
                if (response.data.success == true) {
                    const listparalelos = response.data.data;
                    const cant = listparalelos.length;
                    if (cant != 0) {
                        this.setState({ listparalelos });
                    }
                }
            })

    }

    //BUSQUEDA......
    filter(event) {
        console.log(event.target.value);
        //obtener datos de buscar
        var text = event.target.value
        //obtener datos del array
        const data = this.state.estud
        var newData = data.filter(function (item) {
            //variable del objeto
            const itemDataPrimerApell = item.primer_apellido_estudiante.toUpperCase()
            const itemDataSegundoApell = item.segundo_apellido_estudiante.toUpperCase()
            const itemDataPrimerNom = item.primer_nombre_estudiante.toUpperCase()
            const itemDataSegundoNom = item.segundo_nombre_estudiante.toUpperCase()
            const itemDataCedula = item.numero_identificacion_estudiante.toUpperCase()
            const campo = itemDataPrimerApell + " " + itemDataSegundoApell + " " + itemDataPrimerNom + " " + itemDataSegundoNom + " " + itemDataCedula;
            //variable del buscador
            const textData = text.toUpperCase()
            return campo.indexOf(textData) > -1

        })
        if (text == "") {
            newData = this.state.EstudianteBackup;
        }
        this.setState({
            currentItems: newData,
            textBuscar: text,
        })

    }
    //FUNCION DE PAGINACION POR  MEDIO DE UN CLIC
    handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % listaauxiliar.length;
        this.setState((state) => {
            return { itemOffset: newOffset }
        });
        const endOffset = newOffset + itemsPerPage;
        this.setState({ currentItems: listaauxiliar.slice(newOffset, endOffset) });
        this.setState({ EstudianteBackup: listaauxiliar.slice(newOffset, endOffset) });
        this.setState({ pageCount: Math.ceil(listaauxiliar.length / itemsPerPage) });
        this.setState((state) => {
            return { itemOffset: newOffset }
        });
    }


    handleChangeSelectNivel = async (e) => {
        await this.setState({ [e.target.name]: e.target.value })
        axios
            .post(urlInfoCarrera, {
                idCarreraS: this.state.idCarrera
            })
            .then(response => {
                const codigocarrest = response.data.objcarrea[0].id_carrera;
                const descripcarrest = response.data.objcarrea[0].descripcion_carrera.toUpperCase();
                const nivelcarrest = response.data.objcarrea[0].num_niveles;
                this.setState({ codigoCarrE: codigocarrest });
                this.setState({ descripCarrE: descripcarrest });
                this.setState({ numnivelE: nivelcarrest });
                let listaniveles1 = []
                for (let i = 1; i <= nivelcarrest; i++) {
                    let fila = {
                        codnivel: i,
                        valor: i
                    };
                    listaniveles1.push(fila);
                }
                this.setState({ listaniveles: listaniveles1 });
            })
        //Datos del periodo seleccionado
        axios
            .post(urlInfoPeriod, {
                idPeriodoS: this.state.idPeriodo
            })
            .then(response => {
                const perioddescrip = response.data.data[0].descripcion_periodo_academico;
                this.setState({ txt_periodo: perioddescrip });

            })
        //Fecha actual
        let date = new Date();
        this.setState({ fecha_actual: date.toLocaleDateString() });


    }
    handleChangeMatriculados = async () => {
        this.setState({ currentItems: [] });

        //Tomar el texto del select
        var select = document.getElementById("idParalelo"),
            value = select.value,
            text = select.options[select.selectedIndex].innerText;
        this.setState({ nom_paralelo_select: text });

        axios
            .post(UrlListarAsignMatCiclo, {
                idCarrera: this.state.idCarrera,
                idCiclo: this.state.nivelEstu,
            })
            .then(response => {
                var array = response.data.data;
                this.setState({ listaasigencab: array });
                axios.post(urlListEstudMatriPlataf, {
                    idPeriodSelect: this.state.idPeriodo,
                    idCarreraSelect: this.state.idCarrera,
                    idListaAsigna: array,
                    idCicloSelect: this.state.nivelEstu,
                    idParaleloSelect: this.state.idParalelo
                })
                    .then(respuesta => {

                        if (respuesta.data.success == true) {

                            var array = respuesta.data.data;
                            this.setState({ ListEstActaCalif: array });
                            listaauxiliar = array;
                            const estud = array;
                            this.setState((state) => {
                                return { estud: estud }
                            }
                            );
                            const EstudianteBackup = estud;
                            this.setState((state) => {
                                return { EstudianteBackup: EstudianteBackup }
                            });
                            //PAGINACION
                            this.state.itemOffset = 0;
                            const endOffset = this.state.itemOffset + itemsPerPage;
                            this.setState({ currentItems: listaauxiliar.slice(this.state.itemOffset, endOffset) });
                            this.setState({ EstudianteBackup: listaauxiliar.slice(this.state.itemOffset, endOffset) });
                            this.setState({ pageCount: Math.ceil(listaauxiliar.length / itemsPerPage) });
                            this.setState((state) => {
                                return { itemOffset: state.itemOffset + endOffset }
                            });
                            //FIN  DE LA PAGINACION
                        } else {
                            this.setState({ error: "¡No existe información!" });
                            swal({
                                text: "¡No existe información!",
                                icon: "info",
                                button: "Aceptar",
                            });
                        }
                    })
            })
    }

    cambiarEstadoEva = async (idMatricula, estadoActual) => {

        const nuevoEstado = estadoActual === 0 ? 1 : 0;

        axios.post(urlCambiarEstadoEva, {
            idMatricula: idMatricula,
            estadoEva: nuevoEstado
        })
            .then(response => {

                if (response.data.success === true) {

                    const actualizarLista = (lista) =>
                        lista.map(estudiante =>
                            estudiante.id_matricula === idMatricula
                                ? {
                                    ...estudiante,
                                    estadoeva: nuevoEstado
                                }
                                : estudiante
                        );

                    this.setState({
                        currentItems: actualizarLista(this.state.currentItems || []),
                        estud: actualizarLista(this.state.estud || []),
                        EstudianteBackup: actualizarLista(this.state.EstudianteBackup || []),
                        ListEstActaCalif: actualizarLista(this.state.ListEstActaCalif || [])
                    });

                } else {

                    swal({
                        text: "No se pudo actualizar el estado.",
                        icon: "error",
                        button: "Aceptar"
                    });

                }

            })
            .catch(error => {

                console.log(error);

                swal({
                    text: "Ocurrió un error al actualizar el estado.",
                    icon: "error",
                    button: "Aceptar"
                });

            });
    }
    render() {
        return (
            <div className="row animate__animated animate__fadeIn">
                <ol className="breadcrumb mb-4">
                    <li className="breadcrumb-item active">{/* Título dinámico aquí */}</li>
                </ol>

                <div className="card p-3 mb-2 bg-white rounded-4 shadow-sm border-0">
                    <div className="back-istmas d-flex align-items-center">
                        <i className="far fa-sticky-note me-2"></i>
                        <b className="fw-semibold">Lista de Matriculados</b>
                    </div>

                    <div className="p-3 rounded-3">

                        {/* Filtros */}
                        <div className="row g-3 mb-4">
                            <div className="col-12 col-md-3">
                                <label className="form-label text-azul small">
                                    <i className="fa fa-calendar me-1"></i> Período
                                </label>
                                <select
                                    className="form-select form-select-sm"
                                    id="idPeriodo"
                                    name="idPeriodo"
                                    value={this.state.idPeriodo}
                                    onChange={this.handleChange}
                                >
                                    <option value="undefined" selected disabled>
                                        Seleccione el período
                                    </option>
                                    {this.state.listaperiodos.map(periodo => (
                                        <option
                                            key={periodo.id_periodo_academico}
                                            value={periodo.id_periodo_academico}
                                        >
                                            {periodo.descripcion_periodo_academico}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-12 col-md-3">
                                <label className="form-label text-azul small">Carrera</label>
                                <select
                                    className="form-select form-select-sm"
                                    id="idCarrera"
                                    name="idCarrera"
                                    value={this.state.idCarrera}
                                    onChange={this.handleChangeSelectNivel}
                                >
                                    <option value="undefined" selected disabled>
                                        Seleccione una carrera
                                    </option>
                                    {this.state.carrera.map(c => (
                                        <option key={c.id_carrera} value={c.id_carrera}>
                                            {c.descripcion_carrera}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-12 col-md-3">
                                <label className="form-label text-azul small">Nivel</label>
                                <select
                                    className="form-select form-select-sm"
                                    id="nivelEstu"
                                    name="nivelEstu"
                                    value={this.state.nivelEstu}
                                    onChange={this.handleChange}
                                >
                                    <option value="undefined" selected disabled>
                                        Seleccione
                                    </option>
                                    {this.state.listaniveles.map(n => (
                                        <option key={n.codnivel} value={n.codnivel}>
                                            {n.valor}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-12 col-md-3">
                                <label className="form-label text-azul small">
                                    <i className="fa fa-calendar me-1"></i> Paralelo
                                </label>
                                <select
                                    className="form-select form-select-sm"
                                    id="idParalelo"
                                    name="idParalelo"
                                    value={this.state.idParalelo}
                                    onChange={this.handleChange}
                                >
                                    <option value="undefined" selected disabled>
                                        Seleccione un paralelo
                                    </option>
                                    {this.state.listparalelos.map(p => (
                                        <option key={p.id_paralelo} value={p.id_paralelo}>
                                            {p.nombre_paralelo}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        {/* Botón Buscar */}
                        <div className="d-flex justify-content-end mb-1">
                            <button
                                id="agregar"
                                type="button"
                                className="btn btn-primary fw-semibold"
                                onClick={this.handleChangeMatriculados}
                            >
                                Buscar
                            </button>
                        </div>

                        {/* Buscador */}
                        <div className="row g-3 mb-4 justify-content-center">
                            <div className="col-12 col-md-6">
                                <label className="form-label text-azul small">
                                    <i className="fa fa-search me-1"></i> Buscar:
                                </label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    value={this.state.text}
                                    placeholder="Buscar..."
                                    onChange={e => this.filter(e)}
                                />
                            </div>
                        </div>

                        {/* Tabla oculta para exportación */}
                        <div className="table-responsive mb-4" hidden>
                            <table id="tablamatriculados" className="table text-left" hidden >
                                <thead >
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>

                                        <td>
                                            <img src="https://www.istmas.edu.ec/images/descargas/logos/logoh.png" width="35%" height="auto" />
                                        </td>
                                    </tr>
                                    <tr></tr>
                                    <tr></tr>
                                    <tr></tr>
                                    <tr></tr>
                                    <tr></tr>
                                    <tr></tr>
                                    <tr></tr>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <th style={{ fontSize: 20 }} colspan="5" scope="col">LISTA DE MATRICULADOS</th>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <th scope="col">Carrera</th>
                                        <td scope="col">{this.state.descripCarrE}</td>
                                        <th scope="col">Ciclo</th>
                                        <td scope="col">

                                            {(() => {

                                                //Paralelo
                                                switch (this.state.nivelEstu) {
                                                    case "1": return "PRIMER CICLO";
                                                    case "2": return "SEGUNDO CICLO";
                                                    case "3": return "TERCER CICLO";
                                                    case "4": return "CUARTO CICLO";
                                                    case "5": return "QUINTO CICLO";
                                                    case "6": return "SEXTO CICLO";
                                                    default: return ""
                                                }
                                            })()}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <th scope="col"></th>
                                        <td scope="col"></td>
                                        <th scope="col">Paralelo</th>
                                        <td scope="col">
                                            {this.state.nom_paralelo_select}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <th scope="col">Período</th>
                                        <td scope="col">{this.state.txt_periodo}</td>
                                        <th scope="col">Fecha</th>
                                        <td scope="col">{this.state.fecha_actual}</td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <th style={{ 'borderColor': "#4D4D4D", 'borderStyle': 'solid' }} scope="col">No</th>
                                        <th style={{ 'borderColor': "#4D4D4D", 'borderStyle': 'solid' }} scope="col">username</th>
                                        <th style={{ 'borderColor': "#4D4D4D", 'borderStyle': 'solid' }} scope="col">password</th>
                                        <th style={{ 'borderColor': "#4D4D4D", 'borderStyle': 'solid' }} scope="col">firstname</th>
                                        <th style={{ 'borderColor': "#4D4D4D", 'borderStyle': 'solid' }} scope="col">lastname</th>
                                        <th style={{ 'borderColor': "#4D4D4D", 'borderStyle': 'solid' }} scope="col">email</th>
                                        <th style={{ 'borderColor': "#4D4D4D", 'borderStyle': 'solid' }} scope="col">institution</th>
                                        <th style={{ 'borderColor': "#4D4D4D", 'borderStyle': 'solid' }} scope="col">department</th>
                                        <th style={{ 'borderColor': "#4D4D4D", 'borderStyle': 'solid' }} scope="col">address</th>
                                        <th style={{ 'borderColor': "#4D4D4D", 'borderStyle': 'solid' }} scope="col">city</th>
                                        <th style={{ 'borderColor': "#4D4D4D", 'borderStyle': 'solid' }} scope="col">country</th>
                                        <th style={{ 'borderColor': "#4D4D4D", 'borderStyle': 'solid' }} scope="col">lang</th>
                                        <th style={{ 'borderColor': "#4D4D4D", 'borderStyle': 'solid' }} scope="col">idnumber</th>
                                        <th style={{ 'borderColor': "#4D4D4D", 'borderStyle': 'solid' }} scope="col">course1</th>
                                        <th style={{ 'borderColor': "#4D4D4D", 'borderStyle': 'solid' }} scope="col">group1</th>
                                        <th style={{ 'borderColor': "#4D4D4D", 'borderStyle': 'solid' }} scope="col">cohort1</th>
                                        <th style={{ 'borderColor': "#4D4D4D", 'borderStyle': 'solid' }} scope="col">role1</th>

                                    </tr>
                                </thead>
                                <tbody>

                                    {this.state.ListEstActaCalif.map(consola => (
                                        <tr key={consola.id_estudiante}>

                                            <td style={{ 'borderColor': "#4D4D4D", 'borderStyle': 'solid' }}>{consola.num_est}</td>
                                            <td style={{ 'borderColor': "#4D4D4D", 'borderStyle': 'solid' }}>{consola.username.toLowerCase()}</td>
                                            <td style={{ 'borderColor': "#4D4D4D", 'borderStyle': 'solid' }}>{consola.password}</td>
                                            <td style={{ 'borderColor': "#4D4D4D", 'borderStyle': 'solid' }}>{consola.firstname}</td>
                                            <td style={{ 'borderColor': "#4D4D4D", 'borderStyle': 'solid' }}>{consola.lastname}</td>
                                            <td style={{ 'borderColor': "#4D4D4D", 'borderStyle': 'solid' }}>{consola.email_estudiante}</td>
                                            <td style={{ 'borderColor': "#4D4D4D", 'borderStyle': 'solid' }}>ISTMAS</td>
                                            <td style={{ 'borderColor': "#4D4D4D", 'borderStyle': 'solid' }}></td>
                                            <td style={{ 'borderColor': "#4D4D4D", 'borderStyle': 'solid' }}>{consola.direccion_estudiante}</td>
                                            <td style={{ 'borderColor': "#4D4D4D", 'borderStyle': 'solid' }}>{consola.city}</td>
                                            <td style={{ 'borderColor': "#4D4D4D", 'borderStyle': 'solid' }}>{consola.country}</td>
                                            <td style={{ 'borderColor': "#4D4D4D", 'borderStyle': 'solid' }}>es</td>
                                            <td style={{ 'borderColor': "#4D4D4D", 'borderStyle': 'solid' }}>{consola.numero_identificacion_estudiante}</td>
                                            <td style={{ 'borderColor': "#4D4D4D", 'borderStyle': 'solid' }}></td>
                                            <td style={{ 'borderColor': "#4D4D4D", 'borderStyle': 'solid' }}></td>
                                            <td style={{ 'borderColor': "#4D4D4D", 'borderStyle': 'solid' }}></td>
                                            <td style={{ 'borderColor': "#4D4D4D", 'borderStyle': 'solid' }}>student</td>


                                        </tr>
                                    ))}

                                </tbody>
                            </table>
                        </div>

                        {/* Estudiantes Matriculados */}
                        <h6 className="fw-bold text-center mb-3 text-azul small">
                            ESTUDIANTES MATRICULADOS
                        </h6>
                        <div className="table-responsive mb-4">
                            <table
                                id="tablaRECORD"
                                className="table table-sm table-hover align-middle small text-azul"
                            >
                                <thead className="table-light">
                                    <tr>
                                        <th>Nº</th>
                                        <th>CÉDULA</th>
                                        <th>PRIMER APELLIDO</th>
                                        <th>SEGUNDO APELLIDO</th>
                                        <th>PRIMER NOMBRE</th>
                                        <th>SEGUNDO NOMBRE</th>
                                        <th>CORREO</th>
                                        <th>PLATAFORMA</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.currentItems?.map((s, i) => (
                                        <tr className="list-afiliados" key={i}>
                                            <td>{s.num_est}</td>
                                            <td>{s.numero_identificacion_estudiante}</td>
                                            <td>{s.primer_apellido_estudiante}</td>
                                            <td>{s.segundo_apellido_estudiante}</td>
                                            <td>{s.primer_nombre_estudiante}</td>
                                            <td>{s.segundo_nombre_estudiante}</td>
                                            <td>{s.email_estudiante}</td>
                                            <td>
                                                <button
                                                    type="button"
                                                    className={`btn btn-sm ${Number(s.estadoeva) === 0
                                                        ? "btn-danger"
                                                        : "btn-success"
                                                        }`}
                                                    onClick={() =>
                                                        this.cambiarEstadoEva(
                                                            s.id_matricula,
                                                            Number(s.estadoeva)
                                                        )
                                                    }
                                                >
                                                    {Number(s.estadoeva) === 0
                                                        ? "No Matriculado"
                                                        : "Matriculado"}
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        {/* Paginación */}
                        <div className="d-flex justify-content-center">
                            <ReactPaginate
                                previousLabel="<"
                                nextLabel=">"
                                pageCount={this.state.pageCount}
                                onPageChange={this.handlePageClick}
                                containerClassName="pagination pagination-sm-custom"
                                pageLinkClassName="page-link"
                                previousClassName="page-item"
                                previousLinkClassName="page-link"
                                nextClassName="page-item"
                                nextLinkClassName="page-link"
                                activeClassName="active"
                            />
                        </div>

                        {/* Exportar a Excel */}
                        <div className="d-flex justify-content-center">
                            <ReactHTMLTableToExcel
                                id="botonExportarExcel"
                                className="btn btn-sm btn-success"
                                table="tablamatriculados"
                                filename="lista_matriculados"
                                sheet="Matriculados"
                                buttonText="Descargar Excel"
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
